































































import SearchResultEventItem from './SearchResultEventItem.vue';
import SearchResultItemProfile from './SearchResultItemProfile.vue';
import SearchResultDocumentItem from './SearchResultDocumentItem.vue';
import SearchResultMessageItem from './SearchResultMessageItem.vue';
import SearchResultItemMedia from './SearchResultItemMedia.vue';
import { docTypes } from '../../../shared/enums/docTypes';
import clone from 'lodash/clone';
import ObservingContainer from '../../../shared/libs/intersection-observer/components/Container.vue';
import ObservedTarget from '../../../shared/libs/intersection-observer/components/Target.vue';
import CalendarEventModal from '../calendar/CalendarEventModal.vue';
import button from '../../../shared/directives/button.js';
import { useUserProfileStore } from '../../../shared/stores';
import { useSearchExecution } from '../../composables/global_search/useSearchExecution';
import { useStaggerTransition } from '../../../shared/composables/useStaggerTransition';
import { institutionRole } from '../../../shared/enums/institutionRole';
import SearchResultItemGroup from './SearchResultItemGroup.vue';
import SearchResultItemPost from './SearchResultItemPost.vue';
import { mapGetters } from 'vuex';
import { types } from '../../store/types/types';

export default {
  directives: { button: button },
  components: {
    SearchResultItemPost,
    SearchResultItemGroup,
    CalendarEventModal,
    ObservedTarget,
    ObservingContainer,
    SearchResultEventItem,
    SearchResultItemProfile,
    SearchResultDocumentItem,
    SearchResultItemMedia,
    SearchResultMessageItem,
  },
  setup() {
    const { results, mediaResults, isLoading, hasMore, searchedQuery, searchMore } = useSearchExecution();
    const { beforeEnter, enter, leave } = useStaggerTransition();

    return {
      results,
      mediaResults,
      isLoading,
      hasMore,
      searchedQuery,
      searchMore,
      beforeEnter,
      enter,
      leave,
      docTypes,
      institutionRole,
    };
  },
  data: function () {
    return {
      mediaDetail: [],
    };
  },
  computed: {
    ...mapGetters({
      activeGroup: types.GET_ACTIVE_GROUP,
    }),
    userProfileStore() {
      return useUserProfileStore();
    },
    observerOptions() {
      return { rootMargin: '50%' };
    },
    isChild() {
      return this.userProfileStore.institutionRoles.includes(institutionRole.EARLY_STUDENT);
    },
  },
  methods: {
    openEvent({ id, title }) {
      this.$refs.calendarEventModal.show({ id: parseInt(id), title });
    },
    onBottomReached() {
      if (this.isLoading || !this.hasMore) {
        return;
      }
      this.searchMore();
    },
    tagsUpdated(tags) {
      for (const res of this.results) {
        if (res.id == this.mediaDetail[0].id && res.docType == docTypes.MEDIA) {
          res.tags = tags;
        }
      }
    },
    openMedia(originalMedia) {
      const media = clone(originalMedia);
      media.album = { name: media.albumTitle, id: media.albumId };
      media.fromSearch = true;

      if (this.activeGroup?.id != null) {
        this.$router.push({
          name: 'group-media-details',
          params: {
            groupId: this.activeGroup.id,
            mediaId: media.id,
            albumId: media.albumId,
          },
        });
        return;
      }

      if (media.albumId == null) {
        this.$router.push({
          name: 'myMediaDetails',
          params: {
            mediaId: media.id,
          },
        });
        return;
      }

      this.$router.push({
        name: 'mediaDetails',
        params: {
          mediaId: media.id,
          albumId: media.albumId,
        },
      });
    },
  },
};
